module.exports = __webpack_public_path__ + "img/wxgzh.476ecb87.jpg";